import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { ApiProfileInfo } from "@/types";

export const getProfileInfo = async (token: string): Promise<ApiProfileInfo> => {
  const response = await fetch(`${API_URL}/profile`, {
    method: "GET",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
  });

  return handleApiResponse(response);
};
